    jQuery(function ($) {
        if ($('.interviews, .single-interview').length === 0) {
            return;
        }

        // Load the YouTube IFrame API
        let player;

        // Function to convert YouTube URL to embed URL
        function convertToEmbedUrl(url) {
            const urlObj = new URL(url);
            if (urlObj.hostname === 'www.youtube.com' || urlObj.hostname === 'youtube.com') {
                const videoId = urlObj.searchParams.get('v'); // Extract the video ID
                return `https://www.youtube.com/embed/${videoId}`;
            }
            if (urlObj.hostname === 'youtu.be') {
                const videoId = urlObj.pathname.substring(1); // Extract the video ID
                return `https://www.youtube.com/embed/${videoId}`;
            }
            return url; // Return the original URL if it's not a YouTube link
        }

        // Function to initialize the YouTube player
        function initYouTubePlayer(iframe) {
            player = new YT.Player(iframe, {
                events: {
                    onReady: function () {
                        console.log('YouTube Player is ready');
                    },
                },
            });
        }

        // Wait for the YouTube IFrame API to be ready
        window.onYouTubeIframeAPIReady = function () {
            const iframe = $('.interviews__popup-video')[0];
            if (iframe) {
                initYouTubePlayer(iframe);
            }
        };

        $('.interviews').each(function () {
            const $interviewContainer = $(this);
            const $swiperContainer = $interviewContainer.find('.swiper-container')[0];

            // Find the Swiper instance for this container
            const swiperInstance = $swiperContainer.swiper;

            if (!swiperInstance) {
                console.warn('Swiper instance not found for the container:', $swiperContainer);
                return;
            }

            // Handle click event on .interviews__naam
            $interviewContainer.find('.interviews__naam').on('click', function () {
                // Get the index of the clicked name
                const index = $(this).data('index');

                // Remove active class from all names and add to the clicked one
                $interviewContainer.find('.interviews__naam').removeClass('active');
                $(this).addClass('active');

                // Slide to the corresponding index
                swiperInstance.slideTo(index);
            });

            // Update active name on slide change
            swiperInstance.on('slideChange', function () {
                const currentIndex = swiperInstance.activeIndex;
                const $names = $interviewContainer.find('.interviews__naam');
                $names.removeClass('active');
                $names.filter(`[data-index="${currentIndex}"]`).addClass('active');
            });
        });

        $('.interviews, .single-interview').find('.open-popup').on('click', function () {
            const videoUrl = $(this).data('url'); // Get the video URL from data attribute
            const name = $(this).data('name');   // Get the name from data attribute

            // Convert URL to embed URL
            const embedUrl = convertToEmbedUrl(videoUrl);

            // Update the popup's video and name
            $('.interviews__popup-video').attr('src', embedUrl); // Set the YouTube iframe source
            $('.interviews__popup-name').text(name);     // Update the name in the popup

            // Reinitialize the player when the iframe changes
            const iframe = $('.interviews__popup-video')[0];
            if (iframe) {
                initYouTubePlayer(iframe);
            }
        });

        $('.close-popup').on('click', function () {
            if (player && typeof player.pauseVideo === 'function') {
                player.pauseVideo(); // Pause the video using the YouTube API
            }
            // Clear the iframe's source to stop video playback
            $('.interviews__popup-video').attr('src', '');
        });

        $(window).on('click', function(e){
            if (player && typeof player.pauseVideo === 'function') {
                player.pauseVideo(); // Pause the video using the YouTube API
            }
            // Clear the iframe's source to stop video playback
            $('.interviews__popup-video').attr('src', '');
        });
    });
